import { computed, defineComponent } from 'vue'
import { FindexClient } from '@/integrations/findex'
import { useMemoAsync } from '@/utils/async/useMemoAsync'
import { useActiveCrumbName } from '~/composables/useBreadcrumbs'

export default defineComponent(() => {
  definePageMeta({
    layout: 'app',
    breadcrumb: 'Company'
  })

  const route = useRoute()
  const companyId = computed(() => (route.params as { companyId: string }).companyId)

  const assetQuery = useMemoAsync(async () => {
    if (!companyId.value) return undefined
    const [asset] = await FindexClient.getAssetById(companyId.value)
    return asset
  }, [companyId])

  useActiveCrumbName(computed(() => assetQuery.data?.name))

  return () => <NuxtPage />
})
